import { safeApiRequest } from './apiClient';

const ENDPOINT = '/api/admin/rate-limit';

export const fetchRateLimitDurum = async () =>
  safeApiRequest(ENDPOINT, { method: 'GET', skipCsrf: true });

export const rateLimitKapat = async (kapsam, dakika) =>
  safeApiRequest(`${ENDPOINT}/kapat`, { method: 'POST', body: { kapsam, dakika } });

export const rateLimitAc = async (kapsam) =>
  safeApiRequest(`${ENDPOINT}/ac`, { method: 'POST', body: { kapsam } });

/** limiter + anahtar: tek kayıt; yalnız limiter: o limiter'ın tümü; hiçbiri: tüm limiterlar */
export const rateLimitSifirla = async ({ limiter, anahtar } = {}) =>
  safeApiRequest(`${ENDPOINT}/sifirla`, { method: 'POST', body: { limiter, anahtar } });
